var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{staticStyle:{"z-index":"100"},attrs:{"color":"primary","opacity":"1"}},[_c('div',{staticClass:"d-flex flex-column align-center",staticStyle:{"z-index":"100","position":"relative"}})])}
var staticRenderFns = []

export { render, staticRenderFns }